import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the UpdateaddresseditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-updateaddressedit',
  templateUrl: 'updateaddressedit.html',
})
export class UpdateaddresseditPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad UpdateaddresseditPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/updateaddressedit/updateaddressedit.ts